import { SourceDetails } from 'features/layout/types';
import { CustomTileData } from 'features/layout/features/config/types';

export const formatCustomTileToSource = (data: CustomTileData): SourceDetails => ({
  userId: data.name,
  kind: 'custom',
});
